import { createStore } from 'vuex'
import stepper from './stepper'
import form from './form'
import selectedPlan from './selected-plan'
import load from './load'
import contractVerification from './contract-verification'
import internet5g from './internet-5g'

export default createStore({
  modules: {
    stepper,
    form,
    selectedPlan,
    load,
    contractVerification,
    internet5g
  }
})
